import { Stack, Typography } from '@mui/material';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';
import StatRow from './StatRow';
import { formatNumber } from './dashboardFormat';

// Widget 3 — audience size derived from the flow's start list
// (list total / valid opt-in / excluded contacts).
export default function AudienceWidget({ audience, listName, loading, error, onRetry }) {
  return (
    <DashboardWidgetCard
      title='Zielgruppe'
      icon='Groups'
      accent='secondary'
      loading={loading}
      error={error}
      onRetry={onRetry}
      footer={
        <Typography variant='caption' color='text.secondary'>
          Unterdrückte Adressen: {formatNumber(audience?.suppressedAddresses)}
        </Typography>
      }
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }} justifyContent='center'>
        {listName && (
          <Typography variant='caption' color='text.secondary' noWrap title={listName}>
            Liste: {listName}
          </Typography>
        )}
        <StatRow label='Kontakte in der Liste' value={formatNumber(audience?.listTotal)} />
        <StatRow label='Mit gültigem Opt-in' value={formatNumber(audience?.withOptIn)} />
        <StatRow label='Ausgeschlossene Kontakte' value={formatNumber(audience?.excluded)} />
      </Stack>
    </DashboardWidgetCard>
  );
}
